<template>
  <div>
    <ts-spinner
      data-message=""
      data-size="medium"
      :data-visible="loadingDiffViewer || null"
    />
    <div v-if="!loadingDiffViewer && newConfig">
      <ts-board v-if="showUpdatePlan" data-title="Update Plan">
        <!-- eslint-disable vue/no-deprecated-slot-attribute -->
        <div slot="header-actions">
          <ts-tooltip :tooltip="applyConfigurationTooltip" position="left">
            <ts-button
              :disabled.attr="
                !verifiedExecutablePlan || isConfigApplied || null
              "
              type="primary"
              @button-click="$emit('apply-config-update-plan')"
              :busy="isApplyingDeltaPlan || null"
            >
              Apply Configuration
            </ts-button>
          </ts-tooltip>
        </div>
        <p>
          Here you can see the list of actions that you need to verify for
          applying the configuration that you have selected. You can also see
          the list of problems/errors with applying the provided configuration
          file, which are not possible to be applied by the configuration
          service (Edifier). Some of them may need to be applied manually, in
          different ways, such as API calls or using the platform UI.
        </p>
        <div>
          <form data-ts="Form" class="float-right switch-form">
            <fieldset>
              <label
                data-ts-spirit="ts.ui.LabelSpirit"
                class="ts-label ts-spirit ts-engine-webkit ts-haslabel ts-fieldlabel ts-switchlabel"
              >
                <span
                  data-ts-spirit="ts.ui.LabelTextSpirit"
                  class="ts-switch-label"
                >
                  {{
                    verifyAllChanges
                      ? 'Verify All Changes'
                      : 'Unverify All Changes'
                  }}
                </span>
                <input
                  type="checkbox"
                  data-ts-spirit="ts.ui.SwitchSpirit"
                  v-model="verifyAllChanges"
                  class="ts-switch ts-spirit ts-field ts-switchbox ts-engine-webkit"
                  @click="verifyAll(verifyAllChanges)"
                />
                <div
                  data-ts="Spirit"
                  class="ts-switcher ts-engine-webkit ts-spirit ts-checked"
                  data-ts-spirit="ts.ui.Spirit"
                >
                  <i class="ts-icon-cancel"></i>
                  <i class="ts-icon-checked"></i>
                </div>
              </label>
            </fieldset>
          </form>
          <OutPutFormatSelector
            v-if="deltaData.executablePlan"
            @change="outputFormat = $event"
          />
        </div>
        <div class="list-wrapper">
          <template v-if="deltaData.errors">
            <div
              class="alert alert-danger"
              role="alert"
              v-for="error in deltaData.errors"
              :key="error"
            >
              {{ error }}
            </div>
          </template>
          <ExecutableActionList
            ref="actionList"
            :executable-plan-items="deltaData.executablePlan"
            :output-format="outputFormat"
            @verify-change="verifiedExecutablePlan = $event"
          />
        </div>
        <!-- eslint-enable vue/no-deprecated-slot-attribute -->
      </ts-board>
    </div>
  </div>
</template>

<script>
import '@tradeshift/elements.spinner';
import '@tradeshift/elements.text-field';
import ExecutableActionList from './ExecutableActionList';
import OutPutFormatSelector from './OutPutFormatSelector';

export default {
  components: { ExecutableActionList, OutPutFormatSelector },
  inject: ['configUpdateProvidedData'],
  props: {
    newConfig: {
      type: [String, Object],
      default: null,
    },
    loadingDiffViewer: {
      type: Boolean,
      default: false,
    },
    isJsonFile: {
      type: Boolean,
      default: false,
    },
    isConfigApplied: {
      type: Boolean,
      default: false,
    },
    deltaData: {
      type: Object,
      default: () => ({
        errors: [],
        executablePlan: [],
      }),
    },
  },
  emits: ['apply-config-update-plan'],
  data() {
    return {
      outputFormat: 'side-by-side',
      verifiedExecutablePlan: false,
      verifyAllChanges: false,
    };
  },
  computed: {
    applyConfigurationTooltip() {
      return this.verifiedExecutablePlan
        ? 'This will try to apply the following verified actions!'
        : 'You need to verify all the actions to be able to apply the configuration!';
    },
    showUpdatePlan() {
      return (
        this.deltaData?.executablePlan?.length || this.deltaData?.errors?.length
      );
    },
    isApplyingDeltaPlan() {
      return this.configUpdateProvidedData?.isApplyingDeltaPlan;
    },
  },
  methods: {
    verifyAll(value) {
      this.$refs.actionList.verifyAll(value);
      this.verifyAllChanges = !value;
    },
  },
};
</script>
<style>
.verifyAll-button {
  position: relative !important;
  right: 0px !important;
  top: 50px !important;
}
.switch-form {
  margin: 0 0 0 0 !important;
  bottom: -22px !important;
}
.ts-switch-label {
  padding-right: 10px !important;
}
</style>
